import React from "react";
import classNames from "classnames";
import { NavLinkProps } from "../NavLink.types";
import { NAV_LINK_CLASS_NAMES } from "../NavLink.constants";

const PlainLink: React.FC<NavLinkProps> = ({ children, className, to, isMatchOverride, onClick }) => {
   const match = (() =>  {
      if(isMatchOverride) {
         const result = isMatchOverride(to, true);         
         if(result !== undefined)
            return result;         
      }
      return false;      
   })();
   const linkClassNames = classNames(NAV_LINK_CLASS_NAMES.nav, { [NAV_LINK_CLASS_NAMES.navActive] : match }, className);
   return (<a href={to} className={linkClassNames} onClick={onClick}>
      {children}
   </a>);
}

export default PlainLink;